import { render, staticRenderFns } from "./DecisionsExtend.vue?vue&type=template&id=64fe8198&"
import script from "./DecisionsExtend.vue?vue&type=script&lang=js&"
export * from "./DecisionsExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports